import React from 'react'
import { ProgressSpinner } from 'primereact/progressspinner'
import { BlockUI } from 'primereact/blockui';

const Spinner = () => {
    return (
        <BlockUI blocked={true} fullScreen >
        <div className='text-center'>
            <ProgressSpinner />
            <h5>Por favor espere</h5>
        </div>
        </BlockUI>
    )
}

export default Spinner
